import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingaacabpackage() {



  const cardData =
  {
    keyword: 'Pune to 5 Jyotirlinga Cab Package',
    heading: 'Sanavi Travels: Pune to 5 Jyotirlinga Cab Package',
    headingDescription: 'Sanavi Travels offers the best Pune Ashtavinayak Darshan Tour Package, providing comfortable, safe, and well-organized travel for devotees visiting all eight sacred Ashtavinayak temples around Pune. Our package includes AC and Non-AC buses, tempo travellers, and luxury coaches with professional chauffeurs, ensuring smooth and hassle-free journeys with ample seating and luggage space. With flexible one-day and multi-day packages, transparent pricing, pickup and drop services from Pune, and 24/7 support, the tour is ideal for families, groups, and pilgrims seeking a spiritual and convenient experience. Choose Sanavi Travels for a trusted and seamless Ashtavinayak Darshan Tour from Pune, combining comfort, safety, and devotion in a well-planned itinerary.',

    top: 'Top Places to Visit in Maharashtra Jyotirlinga with Sanavi Travels',


"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga, Nashik",
    "description": "Trimbakeshwar Temple, located near Nashik, is one of the 12 Jyotirlingas of Lord Shiva and holds immense religious significance. Situated at the origin of the Godavari River, the temple features a unique three-faced Shiva Linga representing Brahma, Vishnu, and Shiva. Devotees believe that worshipping here cleanses sins and grants spiritual merit. The temple complex also includes smaller shrines, sacred ghats, and beautiful landscaped areas for rituals and festivals."
  },
  {
    "title": "Grishneshwar Jyotirlinga, Ellora",
    "description": "Grishneshwar Temple is the last of the 12 Jyotirlingas and is located near the famous Ellora Caves in Aurangabad district. The temple is known for its exquisite architecture with beautifully carved pillars, halls, and sanctum. It attracts pilgrims seeking blessings for prosperity, devotion, and spiritual fulfillment. Its proximity to the Ellora caves allows visitors to combine heritage exploration with religious pilgrimage."
  },
  {
    "title": "Bhimashankar Jyotirlinga, Pune",
    "description": "Bhimashankar Temple, located in Ambegaon taluka of Pune district, is a Jyotirlinga nestled amidst dense Sahyadri forests. Famous for its spiritual aura and natural surroundings, it is also a hotspot for biodiversity enthusiasts. Pilgrims visit to worship Lord Shiva and experience the tranquil forested environment. The temple is accessible via trekking routes and nearby Manchar town, providing both adventure and devotion."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga, Hingoli",
    "description": "Aundha Nagnath Temple is a Jyotirlinga located in Hingoli district of Maharashtra. Renowned for its historical, architectural, and religious significance, the temple features a wooden Shivalinga adorned with intricate carvings. It attracts devotees from across Maharashtra, especially during festivals like Mahashivratri, and serves as a center of spiritual and cultural activity."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga, Beed",
    "description": "Parli Vaijnath Temple in Beed district is a Jyotirlinga famous for its elaborate Maratha-style architecture, large courtyard, and sanctum housing the powerful Shiva Linga. The temple draws pilgrims seeking health, prosperity, and spiritual upliftment. Parli Vaijnath is also a hub for local festivals and fairs, making it a center for both devotion and cultural celebrations."
  }
]
,



"services": [
{
"name": "Pune to 5 Jyotirlinga Cab Package",
"description": "Pune to 5 Jyotirlinga Cab Package offers a comprehensive and well-planned itinerary for devotees wishing to visit the five famous Jyotirlinga temples. With comfortable vehicles, professional drivers, and timely pickups, the package ensures a safe, smooth, and spiritually enriching journey. Ideal for families, groups, and solo travelers seeking a hassle-free religious tour from Pune."
},
{
"name": "Jyotirlinga Darshan Cab Pune",
"description": "Jyotirlinga Darshan Cab Pune provides reliable and convenient taxi services for visiting the revered Jyotirlinga temples. With experienced drivers, clean vehicles, and flexible scheduling, it ensures devotees can complete their pilgrimage comfortably and safely while focusing on their spiritual experience."
},
{
"name": "Religious Tour Cab Pune",
"description": "Religious Tour Cab Pune offers organized cab services for pilgrims visiting Jyotirlinga temples and other nearby spiritual destinations. With professional drivers, well-maintained vehicles, and tailored itineraries, it guarantees a seamless, comfortable, and fulfilling religious travel experience from Pune."
},
{
"name": "AC Cab Jyotirlinga Tour",
"description": "AC Cab Jyotirlinga Tour provides air-conditioned vehicles for a comfortable and refreshing journey during long-distance Jyotirlinga tours. Ideal for families, elderly travelers, and devotees, these cabs ensure a smooth, relaxing, and enjoyable pilgrimage experience with professional drivers managing all logistics."
},
{
"name": "Luxury Jyotirlinga Package",
"description": "Luxury Jyotirlinga Package offers premium vehicles, personalized itineraries, and top-class service for devotees seeking a high-end pilgrimage experience. With spacious seating, modern amenities, and experienced chauffeurs, this package guarantees a safe, comfortable, and memorable Jyotirlinga tour from Pune."
},
{
"name": "Family Jyotirlinga Trip",
"description": "Family Jyotirlinga Trip is designed for families wanting a comfortable and safe pilgrimage to the Jyotirlinga temples. With spacious cabs, professional drivers, and flexible schedules, it ensures a memorable spiritual journey that is enjoyable for all family members, including children and elderly travelers."
},
{
"name": "Group Travel Jyotirlinga",
"description": "Group Travel Jyotirlinga provides organized cab services for friends, corporate teams, or social groups visiting Jyotirlinga temples. With reliable vehicles, experienced drivers, and coordinated itineraries, it ensures smooth, safe, and comfortable travel for all group members, making the pilgrimage stress-free and enjoyable."
},
{
"name": "Affordable Jyotirlinga Cab",
"description": "Affordable Jyotirlinga Cab offers budget-friendly options for devotees seeking a safe and comfortable pilgrimage. Despite the economical pricing, it provides well-maintained vehicles, professional drivers, and timely service, ensuring a reliable and satisfying Jyotirlinga tour experience from Pune."
},
{
"name": "Chauffeur Driven Cab Tour",
"description": "Chauffeur Driven Cab Tour ensures a stress-free Jyotirlinga pilgrimage by providing professional drivers who handle navigation, traffic, and schedules. Perfect for families, groups, and corporate travelers, it guarantees safe, comfortable, and hassle-free journeys to all five Jyotirlinga temples."
},
{
"name": "Best Jyotirlinga Package Pune",
"description": "Best Jyotirlinga Package Pune guarantees high-quality vehicles, punctual service, and professional drivers for a smooth and memorable pilgrimage. Designed for devotees, families, and groups, it provides a reliable, safe, and spiritually fulfilling tour to all the Jyotirlinga temples from Pune."
},
{
"name": "Multi Temple Cab Tour",
"description": "Multi Temple Cab Tour offers convenient transportation for visiting multiple religious sites, including the Jyotirlinga temples. With experienced drivers, comfortable vehicles, and well-planned itineraries, it ensures devotees can cover all desired temples efficiently and enjoyably."
},
{
"name": "Outstation Cab Pune",
"description": "Outstation Cab Pune provides safe, reliable, and comfortable long-distance cab services for Jyotirlinga tours and other religious or sightseeing trips. With professional drivers, spacious vehicles, and flexible schedules, it ensures a smooth travel experience from Pune to distant temples and return."
},
{
"name": "Online Cab Booking Jyotirlinga",
"description": "Online Cab Booking Jyotirlinga allows devotees and travelers to reserve their pilgrimage cabs easily and quickly. With instant confirmation, multiple vehicle options, transparent pricing, and flexible scheduling, it simplifies planning for a convenient and stress-free Jyotirlinga tour."
},
{
"name": "Pilgrimage Cab Pune",
"description": "Pilgrimage Cab Pune offers dedicated services for religious travelers visiting Jyotirlinga temples and other spiritual destinations. With professional drivers, comfortable vehicles, and organized itineraries, it ensures a safe, convenient, and memorable spiritual journey from Pune."
},
{
"name": "Jyotirlinga Travel Package",
"description": "Jyotirlinga Travel Package provides comprehensive travel solutions for devotees planning to visit all five Jyotirlinga temples. Combining comfort, safety, affordability, and reliable service, it caters to families, groups, and individual travelers, ensuring a fulfilling and hassle-free pilgrimage experience."
}
],
"tableData": [
["Pune to 5 Jyotirlinga Cab Package", "Jyotirlinga Darshan Cab Pune"],
["Religious Tour Cab Pune", "AC Cab Jyotirlinga Tour"],
["Luxury Jyotirlinga Package", "Family Jyotirlinga Trip"],
["Group Travel Jyotirlinga", "Affordable Jyotirlinga Cab"],
["Chauffeur Driven Cab Tour", "Best Jyotirlinga Package Pune"],
["Multi Temple Cab Tour", "Outstation Cab Pune"],
["Online Cab Booking Jyotirlinga", "Pilgrimage Cab Pune"],
["Jyotirlinga Travel Package", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Jejuri Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Jejuri Pune, ideal for group outings, family trips, pilgrimages, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Jejuri Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are well‑versed with Jejuri Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Jejuri Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Jejuri Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Jejuri Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Jejuri Pune?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Jejuri Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Jejuri Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Jejuri Pune?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Jejuri Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Jejuri Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Jejuri Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Jejuri Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Jejuri Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Jejuri Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Jejuri Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    feedback: 'Booked a bus in Jejuri Pune with Sanavi Travels — very comfortable bus and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rekha Shinde',
    feedback: 'Sanavi Travels made our group trip in Jejuri Pune smooth and stress‑free. Highly recommended!',
    rating: 5
  }
];































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Pune to 5 Jyotirlinga Cab Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to 5 Jyotirlinga cab packages with AC and luxury cabs. Perfect for family trips, group travel, and religious tours. Chauffeur-driven, affordable options with online booking for multi-temple pilgrimage.",
  "touristType": "Religious Tour",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to 5 Jyotirlinga Cab Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to 5 Jyotirlinga Cab Package with Sanavi Travels. AC & luxury cabs for family, group, and religious tours. Chauffeur-driven, affordable, multi-temple pilgrimage cab service with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/181.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetofivejyotilingaacabpackage;